import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from 'src/app/modules/core/layout/layout.component';

import { AuthGuardService } from 'src/app/modules/core/services/auth-guard.service';

import { UtilityComponent } from './utility/utility.component';
import { LoginComponent } from 'src/app/modules/retailer/login/login.component';
import { DashboardComponent } from 'src/app/modules/retailer/dashboard/dashboard.component';
import { ChangePasswordComponent } from 'src/app/modules/retailer/change-password/change-password.component';
import { CreateCouponComponent } from 'src/app/modules/retailer/coupon/create-coupon/create-coupon.component';
import { CouponListComponent } from 'src/app/modules/retailer/coupon/coupon-list/coupon-list.component';
import { CouponProductListComponent } from './coupon/coupon-product-list/coupon-product-list.component';
import { DemoNationalCouponListComponent } from './coupon/demo-national-coupon-list/demo-national-coupon-list.component';
import { CouponReportComponent } from 'src/app/modules/retailer/reports/coupon-report/coupon-report.component';
import { CouponDetailedReportComponent } from './reports/coupon-detailed-report/coupon-detailed-report.component';
import { CreateCircularComponent } from 'src/app/modules/retailer/circular/create-circular/create-circular.component';
import { CircularListComponent } from 'src/app/modules/retailer/circular/circular-list/circular-list.component';
import { SmsCampaignListComponent } from './sms-campaign/sms-campaign-list/sms-campaign-list.component';
import { CreateSmsCampaignComponent } from './sms-campaign/create-sms-campaign/create-sms-campaign.component';
import { PushNotificationCampaignListComponent } from './push-notification-campaign/push-notification-campaign-list/push-notification-campaign-list.component';
import { CreatePushNotificationCampaignComponent } from './push-notification-campaign/create-push-notification-campaign/create-push-notification-campaign.component';
import { SalesDataComponent } from './reports/sales-data/sales-data.component';
import { RegionalCouponPaymentsComponent } from 'src/app/modules/retailer/payments/regional-coupon-payments/regional-coupon-payments.component';
import { NationalCouponPaymentsComponent } from 'src/app/modules/retailer/payments/national-coupon-payments/national-coupon-payments.component';

//import { LoyaltyReportComponent } from 'src/app/modules/retailer/loyalty/loyalty-report/loyalty-report.component';
//import { LoyaltySettingsComponent } from 'src/app/modules/retailer/loyalty/loyalty-settings/loyalty-settings.component';
import { LoyaltyHomeComponent } from './loyalty/loyalty-home/loyalty-home.component';

const routes: Routes = [
  { path: 'retailer/util', component: UtilityComponent },
  { path: 'retailer', component: LoginComponent },
  { path: 'retailer/dashboard', component: LayoutComponent, data: { module:'retailer' }, // Dashboard
    children: [
        { path: '', component: DashboardComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-DA' } }
    ]
  },
  { path: 'retailer/change-password', component: LayoutComponent, data: { module:'retailer' }, // Change Password
    children: [
        { path: '', component: ChangePasswordComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-ALL-USERS_ACCESS' } } 
    ]
  },
  { path: 'retailer/create-coupon', component: LayoutComponent, data: { module:'retailer' }, // Create Coupon
    children: [
        { path: '', component: CreateCouponComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-CC' } }
    ]
  },
  { path: 'retailer/coupons', component: LayoutComponent, data: { module:'retailer' }, // Coupon List
    children: [
        { path: '', component: CouponListComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-CL' } }
    ]
  },
  { path: 'retailer/coupon-products', component: LayoutComponent, data: { module:'retailer' }, // Coupon Product List
    children: [
        { path: '', component: CouponProductListComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-CL' } }
    ]
  },
  { path: 'retailer/demo-national-coupons', component: LayoutComponent, data: { module:'retailer' }, // Demo National Coupon List
    children: [
        { path: '', component: DemoNationalCouponListComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-CL' } }
    ]
  },
  { path: 'retailer/manage-circular', component: LayoutComponent, data: { module:'retailer' }, // Manage Circular
    children: [
        { path: '', component: CreateCircularComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-MCR' } }
    ]
  },
  { path: 'retailer/circulars', component: LayoutComponent, data: { module:'retailer' }, // Circular List
    children: [
        { path: '', component: CircularListComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-CRL' } }
    ]
  },
  { path: 'retailer/sms-campaign', component: LayoutComponent, data: { module:'retailer' }, // SMS Campaign List
    children: [
        { path: '', component: SmsCampaignListComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-SMS' } }
    ]
  },
  { path: 'retailer/manage-sms-campaign', component: LayoutComponent, data: { module:'retailer' }, // Manage SMS Campaign
    children: [
        { path: '', component: CreateSmsCampaignComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-SMS' } }
    ]
  },
  { path: 'retailer/push-notification-campaign', component: LayoutComponent, data: { module:'retailer' }, // Push Notification Campaign List
    children: [
        { path: '', component: PushNotificationCampaignListComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-PNO' } }
    ]
  },
  { path: 'retailer/manage-push-notification-campaign', component: LayoutComponent, data: { module:'retailer' }, // Manage Push Notification Campaign
    children: [
        { path: '', component: CreatePushNotificationCampaignComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-PNO' } }
    ]
  },

  { path: 'retailer/reports', component: LayoutComponent, data: { module:'retailer' }, // Reports
    children: [
        { path: '', component: CouponReportComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-RP' } }
    ]
  },
  { path: 'retailer/reports/coupon-details', component: LayoutComponent, data: { module:'retailer' }, // Reports - coupon-details
    children: [
        { path: '', component: CouponDetailedReportComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-RP' } }
    ]
  },
  { path: 'retailer/sales-data', component: LayoutComponent, data: { module:'retailer' }, // Reports - sales-data
    children: [
        { path: '', component: SalesDataComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-SD' } } 
    ]
  },
  { path: 'retailer/payments', component: LayoutComponent, data: { module:'retailer' }, // Payments
    children: [
        { path: '', component: RegionalCouponPaymentsComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-PA' } }
    ]
  },
  { path: 'retailer/payments/national', component: LayoutComponent, data: { module:'retailer' }, // Payments - National
    children: [
        { path: '', component: NationalCouponPaymentsComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-PA' } }
    ]
  },
  
  /*{ path: 'retailer/loyalty', component: LayoutComponent, data: { module:'retailer' }, // Loyalty Report
    children: [
        { path: '', component: LoyaltyReportComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-LOY' } }
    ]
  },
  { path: 'retailer/loyalty/settings', component: LayoutComponent, data: { module:'retailer' }, // Loyalty Settings
    children: [
        { path: '', component: LoyaltySettingsComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-LOY' } }
    ]
  },*/
  { path: 'retailer/loyalty', component: LayoutComponent, data: { module:'retailer' }, // Loyalty
    children: [
        { path: '', component: LoyaltyHomeComponent, canActivate: [AuthGuardService], data: { module:'retailer', menuCode: 'R-LOY' } } 
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RetailerRoutingModule { }
